import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface Props {
  pendingPasToCancel: string[];
  paActiveSamples: { [key: string]: number };
  acceptedPas: string[];
}

export function ArchiveStatus({
  pendingPasToCancel,
  paActiveSamples,
  acceptedPas,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box>
      {acceptedPas.length > 0 && (
        <Flex flexDir="column" gap={2}>
          <Text>
            {t('archive.status.canNotArchiveVersionDueToAcceptedPas')}
          </Text>
          <Flex flexDir="column" gap={1} maxHeight="500px" overflow="auto">
            {acceptedPas.map((x) => (
              <Text key={x}>{x}</Text>
            ))}
          </Flex>
        </Flex>
      )}
      {acceptedPas.length === 0 && pendingPasToCancel.length > 0 && (
        <Flex flexDir="column" gap={2}>
          <Text>
            {t('archive.status.productApprovalsAndSamplesWillBeCancelled')}
          </Text>
          {pendingPasToCancel.map((x) => {
            return (
              <Flex key={x} flexDir="column" gap={0}>
                <Text fontWeight="bold">{x}</Text>
                {paActiveSamples[x] && (
                  <Text variant="sub">
                    {t('archive.status.samplesWillBeCancelled', {
                      count: paActiveSamples[x],
                    })}
                  </Text>
                )}
              </Flex>
            );
          })}
        </Flex>
      )}
    </Box>
  );
}
